const FindCookie = (cookieValue) => {
  return document.cookie.split(';').find((element) => element.match(cookieValue));
};

export default FindCookie;
